/** Hover panel host: visibility is CSS-only (`:has` on parent); this registers the element and keeps attrs in sync for assistive tech helpers. */
if (!customElements.get('wd-information-hover')) {
class WDInformationHover extends HTMLElement {
    /** @type {HTMLButtonElement} */
    infoBtn = null;
    /** @type {HTMLElement} */
    parent = null

    connectedCallback() {
        // move the first title to the top of the content
        const mainContent = this.querySelector('.wd-information-hover__content');
        const richText = this.querySelector('.metafield-rich_text_field');
        if (richText && mainContent) {
            const title = this.querySelector('.metafield-rich_text_field > *:is(h1,h2,h3,h4,h5,h6):first-child');
            if (title) 
                mainContent.prepend(title);
        }

        this.parent = this.closest(this.getAttribute('parent-selector'));
        if (!this.parent)
            return console.warn('WDInformationHover: parent not found');
        this.infoBtn = this.parent.querySelector('.wd-option-info-button');
        if (!this.infoBtn)
            return console.warn('WDInformationHover: info button not found');

        this.bindEvents();
    }

    bindEvents() {
        this.infoBtn?.addEventListener('click', this.handleInfoBtnClick.bind(this));
    }

    /** on click find the information element that matches to the selected value and show it */
    handleInfoBtnClick() {
        // look for the checked radio button in the parent (selected value)
        const radioBtn = this.parent.querySelector('input[type="radio"]:checked');
        if (!radioBtn)
            return;

        const sel = this.getAttribute('listener-selector');
        const listener = sel ? radioBtn.closest(sel) : null;
        if (!listener)
            return;

        const closeBtn = document.createElement('button');
        closeBtn.classList.add('wd-information-hover__close');
        closeBtn.setAttribute('aria-label', 'סגור');
        closeBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-close icon--medium icon--thick icon--stroke-scalable" fill="none" viewBox="0 0 24 24"><path d="M18.75 5.13496L5.25 18.8544" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M18.75 18.8544L5.25 5.13496" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        const backdrop = document.createElement('div');
        backdrop.classList.add('backdrop');

        const show = () => {
            this.classList.add('show');
            this.style.transition = 'none';
            this.after(backdrop);
            this.prepend(closeBtn);
        };
        /** @param {() => void} fn */
        const runVt = (fn) => {
            this.classList.add('transitionOn');
            if (document.startViewTransition) {
                document.startViewTransition(fn).finished.finally(() => this.classList.remove('transitionOn'));
            } else {
                try {
                    fn();
                } finally {
                    this.classList.remove('transitionOn');
                }
            }
        };
        runVt(show);

        const hide = () => {
            this.classList.remove('show');
            backdrop.remove();
            closeBtn.remove();
        };

        [backdrop, closeBtn].forEach((e) =>
            e.addEventListener('click', () => {
                runVt(hide);
            })
        );
    }
}

customElements.define('wd-information-hover', WDInformationHover);
}
